import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from 'react';
import { Box, Dialog, DialogTitle, Typography, IconButton, Link, DialogActions, Grid, withStyles, DialogContent as MuiDialogContent } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { ProfileManager } from '@kailona/core';
import { KailonaButton, KailonaDatePicker, KailonaTextField } from '@kailona/ui';
var styles = {
  dialogActions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  dialogActionsRight: {
    display: 'flex',
    alignItems: 'center'
  }
};
var DialogContent = withStyles({
  root: {
    height: '100%',
    margin: '0 20px 20px 20px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #EAEAEA',
    borderRadius: '5px',
    paddingBottom: '25px'
  }
})(MuiDialogContent);

var ProfileEditModal = /*#__PURE__*/function (_React$Component) {
  _inherits(ProfileEditModal, _React$Component);

  var _super = _createSuper(ProfileEditModal);

  function ProfileEditModal(props) {
    var _this;

    _classCallCheck(this, ProfileEditModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onCancel", function () {
      _this.props.onClose();
    });

    _defineProperty(_assertThisInitialized(_this), "onConfirm", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var profile, patientFullName, patientDob;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                loading: true
              });

              profile = _this.props.profile;

              if (!profile) {
                _context.next = 9;
                break;
              }

              // Update
              profile.patientFullName = _this.profileNameRef.current.value;
              profile.patientDob = _this.profileDobRef.current.value;
              _context.next = 7;
              return ProfileManager.updateProfile(profile);

            case 7:
              _context.next = 13;
              break;

            case 9:
              // Create
              patientFullName = _this.profileNameRef.current.value;
              patientDob = _this.profileDobRef.current.value;
              _context.next = 13;
              return ProfileManager.addProfile({
                patientFullName: patientFullName,
                patientDob: patientDob
              });

            case 13:
              if (typeof _this.props.onUpdate === 'function') {
                _this.props.onUpdate();
              }

              _this.setState({
                loading: false
              });

              _this.props.onClose();

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "onDelete", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var deleteProfile, profile;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              deleteProfile = confirm('Are you sure you want to delete this profile?');

              if (deleteProfile) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              _this.setState({
                loading: true
              });

              profile = _this.props.profile;
              _context2.next = 7;
              return ProfileManager.removeProfile(profile.patientId);

            case 7:
              if (typeof _this.props.onUpdate === 'function') {
                _this.props.onUpdate();
              }

              _this.setState({
                loading: false
              });

              _this.props.onClose();

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _this.profileNameRef = /*#__PURE__*/React.createRef();
    _this.profileDobRef = /*#__PURE__*/React.createRef();
    _this.state = {
      loading: false
    };
    return _this;
  }

  _createClass(ProfileEditModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          profile = _this$props.profile,
          firstTime = _this$props.firstTime;
      var loading = this.state.loading;
      var title = t('ehr', 'Patient Profile');

      if (firstTime) {
        title = t('ehr', 'Welcome');
      } else if (!profile) {
        title = t('ehr', 'New Patient Profile');
      }

      return /*#__PURE__*/React.createElement(Dialog, {
        fullWidth: true,
        maxWidth: "xs",
        open: this.props.isOpen
      }, /*#__PURE__*/React.createElement(DialogTitle, null, /*#__PURE__*/React.createElement(Box, {
        display: "flex",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Box, {
        flexGrow: 1
      }, title), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(IconButton, {
        onClick: this.props.onClose
      }, /*#__PURE__*/React.createElement(CloseIcon, null))))), /*#__PURE__*/React.createElement(DialogContent, null, firstTime && /*#__PURE__*/React.createElement(Box, {
        mb: 3
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 1,
        justify: "center"
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1"
      }, t('ehr', 'Please update your health information for data accuracy.'))), /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1"
      }, t('ehr', 'Enjoy your private health platform, Kailona!'))))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(KailonaTextField, {
        id: "profile-name",
        className: "kailona-MuiTextField",
        label: t('ehr', 'Name'),
        style: {
          backgroundColor: 'transparent !important'
        },
        inputRef: this.profileNameRef,
        defaultValue: profile ? profile.patientFullName : null,
        fullWidth: true
      })), /*#__PURE__*/React.createElement(Box, {
        mt: 2
      }, /*#__PURE__*/React.createElement(KailonaDatePicker, {
        inputRef: this.profileDobRef,
        id: "date",
        ariaLabel: t('ehr', 'Birth Date'),
        defaultValue: profile ? profile.patientDob : null,
        disableFuture: true,
        openTo: "year",
        fullWidth: true
      }))), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 4,
        style: {
          paddingLeft: '15px'
        }
      }, !!profile && profile.relationship !== 'self' && /*#__PURE__*/React.createElement(Link, {
        href: "#",
        onClick: this.onDelete
      }, t('ehr', 'Delete'))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 8,
        align: "right"
      }, /*#__PURE__*/React.createElement(KailonaButton, {
        variant: "outlined",
        class: "default",
        disabled: loading,
        onClick: this.onCancel,
        title: t('ehr', 'Cancel')
      }), /*#__PURE__*/React.createElement(KailonaButton, {
        variant: "outlined",
        class: "primary",
        disabled: loading,
        onClick: this.onConfirm,
        title: t('ehr', 'Confirm'),
        loading: loading,
        style: {
          marginLeft: '8px'
        }
      })))));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return ProfileEditModal;
}(React.Component);

export { ProfileEditModal as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(styles, "styles", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ProfileHeader/ProfileEditModal.js");
  reactHotLoader.register(DialogContent, "DialogContent", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ProfileHeader/ProfileEditModal.js");
  reactHotLoader.register(ProfileEditModal, "ProfileEditModal", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ProfileHeader/ProfileEditModal.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();